import { LocalStorageService } from 'angular-2-local-storage';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { SharedService } from 'app/shared/shared.service';
import { LoggerService } from '../../logger/logger.service';
@Component({
  selector: 'app-verify-contact-warning',
  templateUrl: './verify-contact-warning.component.html',
  styleUrls: ['./verify-contact-warning.component.css']
})
export class VerifyContactWarningComponent implements OnInit {

  public is_loading: boolean;
  public email_verified = false;
  public email_verification_required = false;
  constructor(private router: Router, private sharedService: SharedService,private logger:LoggerService, private localStorageService: LocalStorageService) {
    this.is_loading = false;
    sharedService.setLoader('default_page', true);
    let methodName = this.constructor.name+'.verifyToken';
    if (this.localStorageService.get('token') != null) {
      this.sharedService.verifyToken({ 'token': this.localStorageService.get('token') })
        .then((res) => {
          let logObj = {
            method: methodName,
            request: "token : [masked]",
            response: res
          };
          this.logger.logInfo(JSON.stringify(logObj));
          this.is_loading = true;
          sharedService.setLoader('default_page', false);
          if (res.status === 'success' && res.isTerminated === false) {
            const person = res.results[0]['personal'][0];
            this.email_verified = person.isEmailVerify === 1;
            this.email_verification_required = person.requiresEmailValidation;
            sharedService.setHeaderUserLoggedIn('default_page', true, person);
          } else {
            this.localStorageService.remove('token');
            this.router.navigate(['./enroll']);
          }
        }, (error)=>{
          let logObj = {
            method: methodName,
            request: "token : [masked]",
            exception: error
          };
          this.logger.logError(JSON.stringify(logObj));
        }).catch((ex)=>{
          let logObj = {
            method: methodName,
            request: "token : [masked]",
            exception: ex
          };
          this.logger.logError(JSON.stringify(logObj));
        });

    } else {
      this.router.navigate(['./enroll']);
    }
  }

  ngOnInit() {
  }
  updateEmailVerified(verified: boolean) {
    this.email_verified = verified;
    if (verified) {
      this.gotoDashboard();
    }
  }
  gotoDashboard() {
    this.localStorageService.set('skip_otp', true);
    this.router.navigate(['./dashboard']);
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/verify-contact-warning/verify-contact-warning.component.ts